export const DefaultParameters = (): LocalParameters => {
  return {
    defaultApiUrl: "https://mistersydapi.mistercacloud.com",
    rowColors: {
      INCOMING:{
        UNKNOWN: "C1CD83",
        MOBILE: "A7BA57",
        NATIONAL: "B4C46E",
        ONEPHONE: "C1CD83",
        FREEPHONE: "C1CD83",
        HIGHRATELINE: "8B9946",
        SPECIALSERVICES: "C1CD83",
        LOCAL: "C1CD83",
        INTERNATIONAL: "8B9946",
        INTERNAL: "A6CAF0"
      },
      OUTGOING:{
        UNKNOWN: "DF8769",
        MOBILE: "D25E42",
        NATIONAL:	"D87355",
        ONEPHONE: "DF8769",
        FREEPHONE: "DF8769",
        HIGHRATELINE: "AD5037",
        SPECIALSERVICES: "DF8769",
        LOCAL: "D87355",
        INTERNATIONAL: "AD5037",
        INTERNAL: "7BA3C6"
      }
    },
    logoutIdle: {
      enable: true,
      logoutTime: 1800000,
      cancelModalTime: 30000
    }
  }
}